import KpiCard from "../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../utils/Constants";
import { AppStrings } from "../../utils/constants/AppStrings";

export interface ReportingSummaryKpisProps {
  turnover: number;
  pnl: number;
  /** Decimal ratio (0..1); converted to a percent at the UI boundary. */
  margin: number;
  currencySymbol?: string;
  isFetching?: boolean;
  isError?: boolean;
}

const ERROR_FALLBACK = "-";

function ReportingSummaryKpis({
  turnover,
  pnl,
  margin,
  currencySymbol,
  isFetching = false,
  isError = false,
}: ReportingSummaryKpisProps) {
  const marginPercent = margin * 100;

  if (isError) {
    return (
      <div
        className="reporting-summary-kpis"
        data-testid="reporting-summary-kpis"
      >
        <KpiCard
          title={AppStrings.TURNOVER}
          value={ERROR_FALLBACK}
          hugeValue={false}
          percentage={undefined}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
          displayAsRawText
        />
        <KpiCard
          title={AppStrings.PROFIT_LOSS}
          value={ERROR_FALLBACK}
          hugeValue={false}
          percentage={undefined}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
          displayAsRawText
        />
        <KpiCard
          title={AppStrings.MARGIN}
          value={ERROR_FALLBACK}
          hugeValue={false}
          percentage={undefined}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
          displayAsRawText
        />
      </div>
    );
  }

  return (
    <div
      className="reporting-summary-kpis"
      data-testid="reporting-summary-kpis"
    >
      <KpiCard
        title={AppStrings.TURNOVER}
        value={turnover}
        hugeValue={false}
        percentage={undefined}
        backgroundColor={KPI_CARD_BACKGROUND.DARK}
        currencySymbol={currencySymbol}
        isApiRunning={isFetching}
      />
      <KpiCard
        title={AppStrings.PROFIT_LOSS}
        value={pnl}
        hugeValue={false}
        percentage={undefined}
        backgroundColor={KPI_CARD_BACKGROUND.DARK}
        currencySymbol={currencySymbol}
        isApiRunning={isFetching}
      />
      <KpiCard
        title={AppStrings.MARGIN}
        value={marginPercent}
        hugeValue={false}
        percentage={undefined}
        rate
        backgroundColor={KPI_CARD_BACKGROUND.DARK}
        isApiRunning={isFetching}
      />
    </div>
  );
}

export default ReportingSummaryKpis;
